import React, { createContext, useContext, useState } from "react";

const UserRoleContext = createContext();

export function useUserRole() {
  return useContext(UserRoleContext);
}

export function UserRoleProvider({ children }) {
  const [role, setRole] = useState(null);
  return (
    <UserRoleContext.Provider value={{ role, setRole }}>
      {children}
    </UserRoleContext.Provider>
  );
}
